module.exports = __webpack_public_path__ + "img/gujuncai.e4450557.png";